import { Dialog, Typography, DialogContent, DialogTitle, DialogActions } from "@mui/material";
import { Button } from "@mui/material";
import React from "react";

interface ConfirmationDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  cofirmButtonColor: "inherit" | "primary" | "secondary" | "success" | "error" | "info" | "warning";
  title: string;
  content: string;
  confirmButtonText: string;
}

/**
 * A confirmation dialog component to confirm an action
 * @param open - Whether the dialog is open
 * @param onClose - Function to close the dialog
 * @param onConfirm - Function to confirm the dialog
 * @param cofirmButtonColor - Color of the confirm button (inherit, primary, secondary, success, error, info, warning)
 * @param title - Title of the dialog
 * @param content - Content of the dialog
 * @param confirmButtonText - Text of the confirm button
 * @returns A confirmation dialog component
 */
const ConfirmationDialog = ({
  open,
  onClose,
  onConfirm,
  cofirmButtonColor,
  title,
  content,
  confirmButtonText,
}: ConfirmationDialogProps) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Typography>{content}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Abbrechen</Button>
        <Button onClick={onConfirm} color={cofirmButtonColor} variant="contained">
          {confirmButtonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
